// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";

// const OrderDetail = () => {
//   const { id } = useParams();
//   const [order, setOrder] = useState(null);
//   const token = localStorage.getItem("auth-token");

//   useEffect(() => {
//     fetch(`${BASE_URL}/order/${id}`, {
//       headers: { "auth-token": token },
//     })
//       .then(res => res.json())
//       .then(data => setOrder(data));
//   }, [id]);

//   if (!order) return <p>Loading...</p>;

//   return (
//     <div className="order-detail">
//       <h2>Order Details</h2>

//       <p><b>Status:</b> {order.status}</p>
//       <p><b>Total:</b> ${order.totalAmount}</p>

//       <h3>Shipping Address</h3>
//       <p>{order.address.name}</p>
//       <p>{order.address.phone}</p>
//       <p>{order.address.city}</p>
//       <p>{order.address.address}</p>

//       <h3>Products</h3>

//       {order.cartItems.map((item, i) => (
//         <div key={i} className="order-item">
//           <p>Product ID: {item._id}</p>
//           <p>Size: {item.size || "-"}</p>
//           <p>Qty: {item.qty}</p>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default OrderDetail;
// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";

// const OrderDetail = () => {
//   const { id } = useParams();
//   const [order, setOrder] = useState(null);
//   const token = localStorage.getItem("auth-token");

// useEffect(() => {
//   if (!token) return;

//   fetch(`${BASE_URL}/order/${id}`, {
//     headers: { "auth-token": token }
//   })
//     .then(res => res.json())
//     .then(data => setOrder(data));

// }, [id, token]);


//   if (!order) return <p>Loading...</p>;

//   return (
//     <div className="order-detail">
//       <h2>Order Details</h2>

//       <p><b>Status:</b> {order.status}</p>
//       <p><b>Total:</b> ${order.totalAmount}</p>

//       <h3>Shipping Address</h3>
//       <p>{order.address.name}</p>
//       <p>{order.address.phone}</p>
//       <p>{order.address.city}</p>
//       <p>{order.address.address}</p>

//       <h3>Products</h3>

//    {order.cartItems.map((item, i) => (
//   <div key={i}>
//     <img src={item.product?.image} width="80" alt="" />
//     <p>{item.product?.product_name}</p>
//     <p>Size: {item.size || "-"}</p>
//     <p>Qty: {item.qty}</p>
//     <p>Price: ${item.product?.new_price}</p>
//   </div>
// ))}

//     </div>
//   );
// };

// export default OrderDetail;
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../Pages/CSS/OrderDetail.css";
import BASE_URL from '../Config/api.js';
const OrderDetail = () => {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const token = localStorage.getItem("auth-token");

  useEffect(() => {
    if (!token) return;

    fetch(`${BASE_URL}/order/${id}`, {
      headers: { "auth-token": token },
    })
      .then((res) => res.json())
      .then((data) => setOrder(data));
  }, [id, token]);

  if (!order) {
    return <p className="loading-text">Loading order details...</p>;
  }

  return (
    <div className="order-detail-container">
      <h2 className="page-title">Order Details</h2>

      {/* ORDER SUMMARY */}
      <div className="order-summary-card">
        <div className="summary-row">
          <span>Order ID</span>
          <span>#{order._id}</span>
        </div>

        <div className="summary-row">
          <span>Status</span>
          <span className={`status-badge ${order.status?.toLowerCase()}`}>
            {order.status}
          </span>
        </div>
        
        <div className="summary-row total">
          <span>Total Amount</span>
          <span>Rs.{order.totalAmount}</span>
        </div>
      </div>

      {/* SHIPPING ADDRESS */}
      <div className="address-card">
        <h3>Shipping Address</h3>
        <p><strong>Name:</strong> {order.address.name}</p>
        <p><strong>Phone:</strong> {order.address.phone}</p>
        <p><strong>City:</strong> {order.address.city}</p>
        <p><strong>Address:</strong> {order.address.address}</p>
      </div>

      {/* PRODUCTS */}
      <div className="products-card">
        <h3>Ordered Products</h3>

        {order.cartItems.map((item, i) => (
          <div key={i} className="product-row">
            <img
              src={item.product?.image}
              alt={item.product?.product_name}
              className="product-image"
            />

            <div className="product-info">
              <h4>{item.product?.product_name}</h4>
              <p>Size: {item.size || "-"}</p>
              <p>Quantity: {item.qty}</p>
            </div>

            <div className="product-price">
              Rs.{item.product?.new_price}
              {/* <p><span>Shipping fee</span> Rs 150</p> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderDetail;
